import React from 'react';

import getWpJson from './getWpJson';
import ArticleBriefing from '../Section/ArticleBriefing';
import ArticleSmall from '../Category/ArticleSmall';
import ArticleBig from '../Section/ArticleBig';

export default async function buildArticles(articles, type = 'big') {
    const response = await Promise.all(articles.map(async (article) => {

        const mediaObject = await getWpJson(article._links['wp:featuredmedia'][0].href)
        console.log(mediaObject)
        const mediaJson = mediaObject.media_details.sizes;

        const medium =       await mediaJson.medium       == undefined ? article.jetpack_featured_media_url : mediaJson.medium.source_url;
        const portrait =     await mediaJson.portrait     == undefined ? article.jetpack_featured_media_url : mediaJson.portrait.source_url;
        const medium_large = await mediaJson.medium_large == undefined ? article.jetpack_featured_media_url : mediaJson.medium_large.source_url;
        const large =        await mediaJson.large        == undefined ? article.jetpack_featured_media_url : mediaJson.large.source_url;
        const full =         await mediaJson.full         == undefined ? article.jetpack_featured_media_url : mediaJson.full.source_url;

        const srcSet = `${medium} 300w, ${portrait} 460w, ${medium_large} 600w, ${large} 1024w, ${full} 1536w`

        const authorObject = await getWpJson(article._links['author'][0].href)


        switch (type) {
            case 'big':
                return <ArticleBig post={article} srcSet={srcSet} author={authorObject.name} authorLink={authorObject.link} key={article.id}/>
                break;
            case 'small':
                return <ArticleSmall post={article} srcSet={srcSet} author={authorObject.name} authorLink={authorObject.link} key={article.id}/>
                break;
            case 'briefing':
                return <ArticleBriefing post={article} srcSet={srcSet} author={authorObject.name} authorLink={authorObject.link} key={article.id}/>
                break;
        }
    }))

    return response;
}